export var DEFAULT_BACKGROUND_OPACITY={identifier:"BLACK",value:"#000",opacityLabel:"100%"};